import { Button, Col, Drawer, Form, Input, Row, Space, Spin } from "antd";
import { Component } from "react";
import "../styles/general.css";

import { UPDATE } from "../constants/request-type";
import { allergens, update_allergens } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import { uploadFile } from "../functions/upload-file";

import logger from '../../utils/logger.js';
const { TextArea } = Input;

const token = sessionStorage.getItem("auth_token");

class Allergens_edit extends Component {
  state = {
    visible: false,
    name: this.props.row.name,
    eng_name: this.props.row.eng_name,
    description: this.props.row.description,
    eng_description: this.props.row.eng_description,
    icon: null,
    locked: false,
    load: false
  };

  componentDidMount() {}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    e.preventDefault();
    return this.setState({ icon: e.target.files[0] });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { name, eng_name, description, eng_description, icon } = this.state;

    const data = {
      name: name.toLowerCase(),
      description: description.toLowerCase(),
      eng_name: eng_name.toLowerCase(),
      eng_description: eng_description.toLowerCase()
    };

   

    let icon_url;
    if (icon !== null) {
      icon_url = await uploadFile(icon);
      if (!icon_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          "Une erreur est survenue lors de l'envoie de l'image, veuillez ressayer"
        );
      }
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: allergens + "/" + update_allergens + "/" + this.props.row._id,
      data: {
        ...data,
        icon: icon !== null ? icon_url.data.url : this.props.row.icon
      },
      token: token
    };

    if (data.name.length === 0 || data.eng_name.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    if (data.description.length === 0 || data.eng_description.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Veuillez fournir une description en anglais et français"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { name, eng_name, description, eng_description, icon, load } =
      this.state;
    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Modifier
        </Button>
        <Drawer
          title="Modifier une allergie"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                 
                  label="Nom"
                  rules={[
                    {
                      required: true,
                      title: "allergie"
                    }
                  ]}
                >
                  <Input
                    name="name"
                    placeholder="nom"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                 
                  label="Nom anglais"
                  rules={[
                    {
                      required: true,
                      title: "allergie"
                    }
                  ]}
                >
                  <Input
                    name="eng_name"
                    placeholder="nom"
                    onChange={this.handleChange}
                    value={eng_name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Description"
                  rules={[
                    {
                      required: true,
                      text: "Description"
                    }
                  ]}
                >
                  <Input
                    name="description"
                    placeholder="description"
                    onChange={this.handleChange}
                    value={description}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Description en anglais"
                  rules={[
                    {
                      required: true,
                      text: "Description"
                    }
                  ]}
                >
                  <TextArea
                    rows={5}
                    name="eng_description"
                    placeholder="description anglais"
                    onChange={this.handleChange}
                    value={eng_description}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="icon"
                  label="Icon"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImageChange}
                    value={icon}
                    name="icon"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Allergens_edit;
